export const HamburgerIcon: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props
) => (
  <svg
    fill='none'
    viewBox='0 0 30 28'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g fill='currentColor'>
      <rect height='3.33333' rx='1.66667' width='30' y='.666504' />
      <rect height='3.33333' rx='1.66667' width='30' y='12.333' />
      <rect height='3.33333' rx='1.66667' width='30' y='24' />
    </g>
  </svg>
);
